/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_line_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comma-, tab- or space-separated rows. The first column is the x-axis and each numeric column is a line; an all-text first row is used as the legend header.`)
};

const es_line_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filas separadas por comas, tabulaciones o espacios. La primera columna es el eje X y cada columna numérica es una línea; una primera fila totalmente de texto se usa como cabecera de leyenda.`)
};

const de_line_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durch Kommas, Tabulatoren oder Leerzeichen getrennte Zeilen. Die erste Spalte ist die x-Achse, und jede numerische Spalte ist eine Linie; eine reine Text-Kopfzeile wird als Legenden-Kopfzeile verwendet.`)
};

const nl_line_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komma-, tab- of spatiegescheiden rijen. De eerste kolom is de x-as en elke numerieke kolom is een lijn; een eerste rij die volledig uit tekst bestaat wordt als legendaheader gebruikt.`)
};

const fr_line_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des lignes séparées par des virgules, des tabulations ou des espaces. La première colonne est l'axe des x et chaque colonne numérique est une courbe ; une première ligne entièrement textuelle est utilisée comme en-tête de légende.`)
};

const it_line_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Righe separate da virgole, tabulazioni o spazi. La prima colonna è l'asse x e ogni colonna numerica è una linea; una prima riga interamente testuale viene usata come intestazione della legenda.`)
};

const pt_br2_line_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linhas separadas por vírgula, tabulação ou espaço. A primeira coluna é o eixo x e cada coluna numérica é uma linha; uma primeira linha totalmente textual é usada como cabeçalho da legenda.`)
};

const pt_line_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linhas separadas por vírgulas, tabulações ou espaços. A primeira coluna é o eixo X e cada coluna numérica é uma linha; uma primeira linha totalmente textual é usada como cabeçalho da legenda.`)
};

const ja_line_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カンマ、タブ、またはスペース区切りの行です。最初の列がx軸、各数値列が1本の線になります。すべて文字の最初の行は凡例のヘッダーとして使われます。`)
};

const zh_line_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以逗号、制表符或空格分隔的行。第一列是 x 轴，每个数值列是一条线；如果第一行全为文本，则用作图例表头。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const line_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.line_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("line_faq_a1", locale)
	if (locale === "en") return en_line_faq_a1(inputs)
	if (locale === "es") return es_line_faq_a1(inputs)
	if (locale === "de") return de_line_faq_a1(inputs)
	if (locale === "nl") return nl_line_faq_a1(inputs)
	if (locale === "fr") return fr_line_faq_a1(inputs)
	if (locale === "it") return it_line_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_line_faq_a1(inputs)
	if (locale === "pt") return pt_line_faq_a1(inputs)
	if (locale === "ja") return ja_line_faq_a1(inputs)
	return zh_line_faq_a1(inputs)
};